/**
 * Klaviyo Back in Stock — trigger visibility
 * Shows the BIS anchor only when the selected variant is sold out,
 * matching PDP behavior inside Quick Add and on the product page.
 */
(function () {
  function shouldShowBis(productInfo) {
    if (!productInfo?.querySelector('[data-klaviyo-bis-trigger]')) return false;

    if (window.SizeSelection?.requiresSelection(productInfo)) {
      if (!window.SizeSelection.isSizeSelected(productInfo)) {
        return window.SizeSelection.areAllSizesSoldOut(productInfo);
      }

      const selectedVariant =
        window.SizeSelection.getSelectedVariant(productInfo);
      const selectedSizeInput =
        window.SizeSelection.getSelectedSizeInput(productInfo);
      const variantSizeValue = window.SizeSelection.getSizeValueFromVariant(
        productInfo,
        selectedVariant
      );
      const variantMatchesSelection =
        !selectedSizeInput?.value ||
        !variantSizeValue ||
        selectedSizeInput.value === variantSizeValue;

      if (variantMatchesSelection && selectedVariant) {
        return !selectedVariant.available;
      }

      return (
        selectedSizeInput?.disabled ||
        selectedSizeInput?.classList?.contains('disabled') ||
        selectedSizeInput?.getAttribute('aria-disabled') === 'true'
      );
    }

    const variantScript = productInfo.querySelector(
      'variant-selects [data-selected-variant]'
    );
    if (!variantScript?.textContent) return false;

    try {
      const variant = JSON.parse(variantScript.textContent);
      return Boolean(variant && !variant.available);
    } catch {
      return false;
    }
  }

  function updateBisVisibility(productInfo) {
    const trigger = productInfo?.querySelector('[data-klaviyo-bis-trigger]');
    if (!trigger) return;

    trigger.classList.toggle('is-visible', shouldShowBis(productInfo));
  }

  function findProductInfoForSection(sectionId) {
    if (!sectionId) return null;

    return document.querySelector(
      `product-info[data-section="${sectionId}"], product-info[data-original-section="${sectionId}"]`
    );
  }

  function updateAllBisVisibility() {
    document.querySelectorAll('product-info').forEach(updateBisVisibility);
  }

  window.KlaviyoBis = {
    shouldShow: shouldShowBis,
    updateVisibility: updateBisVisibility,
    updateAll: updateAllBisVisibility,
  };

  document.addEventListener('product-info:loaded', event => {
    updateBisVisibility(event.target);
  });

  document.addEventListener('variant-selects:updated', event => {
    const productInfo = findProductInfoForSection(event.detail?.sectionId);
    if (productInfo) updateBisVisibility(productInfo);
  });

  document.addEventListener('change', event => {
    const productInfo = event.target.closest('product-info');
    if (!productInfo || !event.target.closest('variant-selects')) return;

    requestAnimationFrame(() => updateBisVisibility(productInfo));
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = findProductInfoForSection(data?.sectionId);
      if (productInfo) updateBisVisibility(productInfo);
    });
  }

  function init() {
    updateAllBisVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
